import { useUserInfoContext, UserInfo } from '@/context/user-info-context';
import { UserRole } from '@/components/authnz/types/rbac';

export type { UserInfo };

/**
 * Format role name for display
 */
export function formatRoleName(role: UserRole): string {
  const roleMap: Record<UserRole, string> = {
    [UserRole.ADMINISTRATOR]: 'Administrator',
    [UserRole.PRACTITIONER_ADMINISTRATOR]: 'Practitioner Administrator',
    [UserRole.PRACTITIONER]: 'Practitioner',
    [UserRole.STUDENT]: 'Student',
    [UserRole.TUTOR]: 'Tutor',
    [UserRole.SALES]: 'Sales',
    [UserRole.CLIENT]: 'Client',
  };
  return roleMap[role] || role;
}

/**
 * Hook to fetch user roles and active subscription
 * Now a thin wrapper around UserInfoContext to maintain backward compatibility.
 */
export function useUserInfo(): UserInfo {
  return useUserInfoContext();
}

